/* eslint-disable handle-callback-err */
/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
export default class Policies extends Component {
  constructor (props) {
    super(props)
    this.state = {
      acceptedPolicies:this.props.acceptedPolicies || false,
      policyLink: '',
      preferredCampus:''
    }
  }
  static getDerivedStateFromProps(props,state) {
    if(props.preferredCampus!==state.preferredCampus)
    {
      return {preferredCampus:props.preferredCampus}
    }else{
      return null
    }
  }

  componentDidMount () {
    
    this.setState({preferredCampus:this.props.preferredCampus})
    fetch(`${process.env.REACT_APP_API_URL}/api/login/getPolicyLink`)
      .then(res => res.json())
      .then(res => {
        this.setState({ policyLink: res })
      })
      .catch(err => this.setState({ policyLink: '#' }))
  }


    

  render () {
    const preferredCampus=this.state.preferredCampus
    return (
      <div>
    
     <p>   o	Meeting the minimum entry requirements does not guarantee admission to the university, but rather ensures entry to the selection and assessment process.</p>
<p>o	Admission to the university is based on your academic records and achievements, with no regards to age, gender, race, color or disability of any kind.</p>
<p>o	Any health-related issues will only be regarded as health-based information and will not affect your acceptance to the university.</p>
<p>o	Refunding the full deposited amount – Down Payment (25,000 EGP for Egyptians – 1,500 GBP for Non-Egyptians) according to the following conditions:</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;o	Within fourteen (14) days from the date of payment (presenting the proof of payment is a must).</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;o	If the applicant is not eligible to receive the final acceptance letter.</p>
<p>o	Application Fees (1,500 EGP) is not refundable.</p>
<p>o	For Egyptian Students Tuition Fees will be calculated according to GBP average “selling” rate announced by Central Bank of Egypt over a specific period of time with minimum exchange rate of 1 GBP = 20 EGP to be applied on tuition fees.</p>
{preferredCampus=='West'? <p>o	Please note that TKH New Zayed Campus <b>is due to</b> operate starting the second semester of 23/24 Academic Year.<br/>o	Students joining the New Zayed Campus will attend the first semester of the 23/24 Academic Year in The New Administrative Capital’s Campus and the second semester at The New Zayed Campus.</p>:null}
<p style={{fontStyle:'italic'}} >Privacy rules prevent us from disclosing information to anyone but you about your application unless you authorize a specific person on your behalf in this section. 
  Once you are admitted, this person will no longer have access to your file.</p>
  <p style={{fontStyle:'italic'}} ><b>If there are any omissions of key information or any documents submitted in support of your application are found to be fraudulent, the University reserves the right to reject or withdraw the application and offer made.</b></p>
  
        <p><input type='checkbox' value={this.state.acceptedPolicies} onChange={() => {
          this.props.collectState('Policies', !this.state.acceptedPolicies)
          this.setState(prevState => ({
            acceptedPolicies: !prevState.acceptedPolicies
          }))
        }
        } checked={this.state.acceptedPolicies}/> Accept Policies</p>
      </div>
    )
  }
}
Policies.propTypes = {
  collectState: PropTypes.func.isRequired,
  acceptedPolicies: PropTypes.bool,
  preferredCampus:PropTypes.string
}
